import { createFileRoute } from "@tanstack/react-router";
import { computeSearch } from "../../features/console/compute-selection";
import { storageLocations } from "../../features/spot/locations";
import { SpotWorkspaceNew } from "../../features/workspaces/spot-storage";
import { WorkspaceNew } from "../../features/workspaces/workspace-new";

export const Route = createFileRoute("/_authed/$org/$project/workspaces/new")({
  validateSearch: (s: Record<string, unknown>) => ({ ...(s.capacity === "spot" ? { capacity: "spot" as const } : {}), ...(typeof s.workspace === "string" ? { workspace: s.workspace } : {}), ...(s.storage === "spot" ? { storage: "spot" as const } : {}), ...(typeof s.from === "string" ? { from: s.from } : {}), ...(typeof s.recover === "string" ? { recover: s.recover } : {}), ...(typeof s.storageLocation === "string" && storageLocations.some((location) => location.value === s.storageLocation) ? { storageLocation: s.storageLocation } : {}), ...computeSearch(s) }),
  component: NewWorkspacePage,
});

function NewWorkspacePage() {
  const { org, project } = Route.useParams();
  const { from, recover, storage, storageLocation, capacity, workspace, ...compute } = Route.useSearch();
  if (storage === "spot") return <SpotWorkspaceNew scope={{ org, project }} initialLocation={storageLocation} />;
  return <WorkspaceNew capacity={capacity} initialWorkspace={workspace} scope={{ org, project }} compute={compute} {...(from ? { from } : {})} {...(recover ? { recover } : {})} />;
}
